export const LANGUAGES = [
  { code: "en", name: "English", native: "English", flag: "gb", rtl: false },
  { code: "ar", name: "Arabic", native: "العربية", flag: "sa", rtl: true },
  { code: "fr", name: "French", native: "Français", flag: "fr", rtl: false },
  { code: "es", name: "Spanish", native: "Español", flag: "es", rtl: false },
  { code: "de", name: "German", native: "Deutsch", flag: "de", rtl: false },
  { code: "pt", name: "Portuguese", native: "Português", flag: "pt", rtl: false },
  { code: "it", name: "Italian", native: "Italiano", flag: "it", rtl: false },
  { code: "tr", name: "Turkish", native: "Türkçe", flag: "tr", rtl: false },
  { code: "hi", name: "Hindi", native: "हिन्दी", flag: "in", rtl: false },
  { code: "ur", name: "Urdu", native: "اردو", flag: "pk", rtl: true },
];
export const LANGUAGE_CODES = LANGUAGES.map((l) => l.code);
export const DEFAULT_LANGUAGE = "en";
export const RTL_LANGUAGES = LANGUAGES.filter((l) => l.rtl).map((l) => l.code);

// Tap Payments settlement currencies. Rates mirror backend/config.py (USD base).
export const CURRENCIES = [
  { code: "USD", name: "US Dollar", symbol: "$", rate: 1.0, decimals: 2, flag: "us" },
  { code: "EUR", name: "Euro", symbol: "€", rate: 0.92, decimals: 2, flag: "eu" },
  { code: "GBP", name: "UK Pound Sterling", symbol: "£", rate: 0.79, decimals: 2, flag: "gb" },
  { code: "AED", name: "UAE Dirham", symbol: "AED", rate: 3.6725, decimals: 2, flag: "ae" },
  { code: "SAR", name: "Saudi Riyal", symbol: "SAR", rate: 3.75, decimals: 2, flag: "sa" },
  { code: "QAR", name: "Qatari Riyal", symbol: "QAR", rate: 3.64, decimals: 2, flag: "qa" },
  { code: "KWD", name: "Kuwaiti Dinar", symbol: "KD", rate: 0.3065, decimals: 3, flag: "kw" },
  { code: "BHD", name: "Bahraini Dinar", symbol: "BD", rate: 0.376, decimals: 3, flag: "bh" },
  { code: "OMR", name: "Omani Riyal", symbol: "OMR", rate: 0.3845, decimals: 3, flag: "om" },
];
export const CURRENCY_CODES = CURRENCIES.map((c) => c.code);
export const DEFAULT_CURRENCY = "USD";

const EURO_REGIONS = ["AT", "BE", "CY", "DE", "EE", "ES", "FI", "FR", "GR", "HR", "IE", "IT", "LT", "LU", "LV", "MT", "NL", "PT", "SI", "SK"];
const REGION_CURRENCY = { KW: "KWD", SA: "SAR", AE: "AED", BH: "BHD", OM: "OMR", QA: "QAR", GB: "GBP" };
EURO_REGIONS.forEach((r) => (REGION_CURRENCY[r] = "EUR"));

export function detectCurrencyFromBrowser() {
  const locales = (typeof navigator !== "undefined" && (navigator.languages?.length ? navigator.languages : [navigator.language])) || [];
  for (const loc of locales) {
    const region = (loc || "").split(/[-_]/)[1];
    if (region && REGION_CURRENCY[region.toUpperCase()]) return REGION_CURRENCY[region.toUpperCase()];
  }
  return DEFAULT_CURRENCY;
}

export function flagUrl(code, size = 40) {
  return `https://flagcdn.com/w${size}/${code}.png`;
}
